import { makeStyles } from "@material-ui/core/styles";
import { Tooltip } from "@mui/material";

const useStyles: any = makeStyles((theme: any) => ({
  customTooltip: {
    backgroundColor: "#577EC6",
    fontSize: "12px",
  },
}));

export default function CustomTooltip(props: any) {
  const classes = useStyles();

  return <Tooltip classes={{ tooltip: classes.customTooltip }} {...props} />;
}
